module.exports = __webpack_public_path__ + "img/delete.e53d4c67.svg";